import {createSelector} from '@reduxjs/toolkit'

const trustAccountSelector = createSelector(
    [state => state.components, 
    state => state.collectionApplicationData],
    ({trustAccount}, appData) => {
        let trustAccountInstitution = {}
        let trustAccountFinancialStatementLetter = {}

        if(appData.trustAccountInstitution) {
            trustAccountInstitution = appData.trustAccountInstitution
        }

        if(appData.trustAccountFinancialStatementLetter) { 
            trustAccountFinancialStatementLetter = appData.trustAccountFinancialStatementLetter
        }
        return {
            ...trustAccount,
            trustAccountInstitution,
            trustAccountFinancialStatementLetter
        }
    }
)

export const trustAccountSelect = (state) => ({
    trustAccount : trustAccountSelector(state)
})

export function populateTrustAccountData(trustAccountInstitution, trustAccountLetterFile) {
    let trustName = ""
    let trustBranch =  ""
    let trustBranchAddress = ""
    let document = ""

    if(trustAccountInstitution) {
        trustName = trustAccountInstitution.name
        trustBranch = trustAccountInstitution.branchName

        if(trustAccountInstitution.address && 
            trustAccountInstitution.address.singleLineAddress)
            trustBranchAddress = trustAccountInstitution.address.singleLineAddress
    }

    if(trustAccountLetterFile && trustAccountLetterFile.filename)
        document = trustAccountLetterFile.filename

    return {
        "Name of financial institution" : trustName,
        "Branch name" : trustBranch,
        "Branch address" : trustBranchAddress,
        "Document from your bank" : document
    }
}
